<p class="label">{{ label }}</p>
<div class="input-with-icon">
  <ng-content></ng-content>
  <i class="material-icons icon">{{ icon }}</i>
  <div [class.note]="!error" [class.error]="error">{{ note }}</div>
</div>
